// extracted by mini-css-extract-plugin
export var actions = "_tz-4";
export var item = "_tz-1";
export var price = "_tz-3";
export var quantity = "_tz-2";
export var table = "_tz-0";